import type { ButtonTypes } from "@/components/button";

export const FORM_APPLICATION_TAB_ITEMS = [
  { value: "all", label: "All types" },
  { value: "book-a-demo", label: "Book a demo" },
  { value: "get-pdf-offer", label: "Get PDF offer" },
  { value: "contact-sales", label: "Contact sales" },
  { value: "contact-confirmation", label: "Contact confirmation" },
] as const;

export const FORM_APPLICATION_PERIOD_OPTIONS = [
  { value: "all", label: "All time" },
  { value: "last-24-hours", label: "Last 24 hours" },
  { value: "last-7-days", label: "Last 7 days" },
  { value: "last-28-days", label: "Last 28 days" },
] as const;

export const FORM_APPLICATION_STATUS_OPTIONS = [
  { value: "all", label: "All statuses" },
  { value: "unread", label: "Unread" },
  { value: "read", label: "Read" },
] as const;

export type FormApplicationType =
  | "book-a-demo"
  | "get-pdf-offer"
  | "contact-sales"
  | "contact-confirmation";

export type FormApplicationTypeFilter = (typeof FORM_APPLICATION_TAB_ITEMS)[number]["value"];
export type FormApplicationPeriod = (typeof FORM_APPLICATION_PERIOD_OPTIONS)[number]["value"];
export type FormApplicationStatus = (typeof FORM_APPLICATION_STATUS_OPTIONS)[number]["value"];

type BadgeVariant = NonNullable<ButtonTypes["variant"]>;

const FORM_APPLICATION_TYPE_META: Record<
  FormApplicationType,
  { label: string; variant: BadgeVariant }
> = {
  "book-a-demo": {
    label: "Book a demo",
    variant: "primary",
  },
  "get-pdf-offer": {
    label: "Get PDF offer",
    variant: "warning",
  },
  "contact-sales": {
    label: "Contact sales",
    variant: "success",
  },
  "contact-confirmation": {
    label: "Contact confirmation",
    variant: "danger",
  },
};

export const getFormApplicationTypeMeta = (type: FormApplicationType) =>
  FORM_APPLICATION_TYPE_META[type];

export const formatFormApplicationTimestamp = (timestamp: number) =>
  new Intl.DateTimeFormat("en", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(timestamp));
